module.exports = "/static-assets/_next/static/images/Poloaroid-10-94278c7320b653f0352beeaff29cb137.png";